import { IOfferForClient1 } from '../../repositories/chats/entities/for_client/OfferForClient1';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage, prepareMessageReply } from '../../utils/messageUtils';
import { setSendMessagePending, trackMessageSent } from '../sendMessage';
import { sendWsMessage } from '../wsMessage';
import { IWsMessageReply } from '../wsMessage/types';

interface IProps {
  offer: IOfferForClient1;
  chatId: string;
  messageId?: string;
  reply?: IWsMessageReply;
}

export const sendOfferMessage =
  ({ offer, chatId, messageId, reply }: IProps): TThunkAction<void> =>
  async (dispatch, getState, context) => {
    const {
      user: { userId },
    } = getState();

    const { messagesMap } = context.custom;
    const messageReply = prepareMessageReply({ messagesMap, replyToMessageId: reply?.messageId });

    const message = createOutcomingMessage({ uid: messageId, chatId, userId, type: 'offer', reply: messageReply });
    message.offers = [offer];

    trackMessageSent({ chatId, messageId: message.messageId, isReply: Boolean(messageReply) });

    dispatch(
      setSendMessagePending({
        message: { ...message, offers: [offer] },
        messageId: messageId || message.messageId,
        messagesMap,
      }),
    );

    await dispatch(sendWsMessage({ message, offers: [offer], reply }));
  };
